/* ==========================================================================
   Produit — comportements
   - coloris : variante, prix, badge, bouton et photos de ce coloris (sans recharger la page)
   - galerie : vignettes (desktop), carrousel + points (mobile), agrandissement
   - desktop : les photos défilent d'abord (colonne d'achat en place), puis la colonne d'achat ; barre d'achat fixe quand le bouton sort de l'écran
   - précommande : la case doit être cochée avant d'ajouter au panier
   - rubriques : onglets (clic, flèches du clavier) façon Polène, accordéons natifs <details>
   - vidéos lues sur place, carrousel « Pensés pour compléter votre sac »
   ========================================================================== */
(function () {
  'use strict';
  var O = window.OBAIA;

  function init(scope) {
    var root = O.$('[data-section="produit"]', scope);
    if (!root || root.__ok) return;
    root.__ok = true;

    var variantes = [];
    try { variantes = JSON.parse(O.$('[data-variantes]', root).textContent); } catch (e) {}
    var form = O.$('[data-form]', root);
    var champ = O.$('[data-variante]', root);
    var bouton = O.$('[data-bouton]', root);
    var confirme = O.$('[data-confirme]', root);
    var erreur = O.$('[data-erreur]', root);
    var note = O.$('[data-note]', root);
    var etat = root.getAttribute('data-etat');
    var courante = variantes.filter(function (v) { return String(v.id) === champ.value; })[0] || variantes[0];

    /* Galerie --------------------------------------------------------------- */
    var photos = O.$('[data-photos]', root);
    var points = O.$('[data-points]', root);
    function visibles() { return O.$$('.pdt__photo', photos).filter(function (f) { return !f.hidden; }); }
    function majPoints() {
      if (!points) return;
      var n = visibles().length;
      points.innerHTML = n > 1 ? new Array(n + 1).join('<i></i>') : '';
      actifPoint();
    }
    function actifPoint() {
      if (!points) return;
      var i = Math.round(photos.scrollLeft / Math.max(1, photos.clientWidth));
      O.$$('i', points).forEach(function (p, k) { p.classList.toggle('is-actif', k === i); });
      // Mobile : pas de loupe sur une vidéo
      var zb = O.$('[data-zoom]', root), cur = visibles()[i];
      if (zb) zb.hidden = !!(cur && cur.hasAttribute('data-pvideo'));
    }
    photos.addEventListener('scroll', function () { window.requestAnimationFrame(actifPoint); }, { passive: true });

    function filtrerPhotos(coloris) {
      var c = (coloris || '').toLowerCase();
      O.$$('.pdt__photo', photos).forEach(function (f) {
        var fc = f.getAttribute('data-coloris') || '';
        f.hidden = !!(fc && c && fc !== c);
        var vig = O.$('[data-vignette="' + f.getAttribute('data-media') + '"]', root);
        if (vig) vig.hidden = f.hidden;
      });
      photos.scrollLeft = 0;
      majPoints();
      vignetteActive();
    }
    // Vignettes : défilement jusqu'à la photo ; la vignette de la photo à l'écran est soulignée
    O.$$('[data-vignette]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var f = O.$('[data-media="' + b.getAttribute('data-vignette') + '"]', photos);
        if (!f) return;
        // Position de la photo dans la page (la pile de photos peut être figée à l'écran : on part de la section)
        var y = root.getBoundingClientRect().top + window.scrollY + parseFloat(getComputedStyle(root).paddingTop) + f.offsetTop - (O.$('[data-header]') || { offsetHeight: 0 }).offsetHeight - 32;
        window.scrollTo({ top: y, behavior: O.reduce ? 'auto' : 'smooth' });
      });
    });
    function vignetteActive() {
      if (!O.isDesktop()) return;
      var milieu = window.innerHeight / 2, actif = null;
      visibles().forEach(function (f) { var r = f.getBoundingClientRect(); if (r.top < milieu) actif = f; });
      actif = actif || visibles()[0];
      O.$$('[data-vignette]', root).forEach(function (b) { b.classList.toggle('is-actif', !!actif && b.getAttribute('data-vignette') === actif.getAttribute('data-media')); });
    }
    window.addEventListener('scroll', function () { window.requestAnimationFrame(vignetteActive); }, { passive: true });

    // Agrandissement
    var fen = O.$('[data-zoom-fenetre]', root), fenImg = O.$('[data-zoom-image]', root);
    function zoom(fig) {
      var img = O.$('img', fig); if (!img || !fen) return;
      var grand = img.cloneNode(); grand.removeAttribute('loading'); grand.sizes = '100vw';
      fenImg.innerHTML = ''; fenImg.appendChild(grand);
      fen.hidden = false; document.documentElement.classList.add('filtres-ouverts');
      O.$('[data-zoom-fermer]', fen).focus();
    }
    function dezoom() { if (!fen || fen.hidden) return; fen.hidden = true; document.documentElement.classList.remove('filtres-ouverts'); }
    photos.addEventListener('click', function (e) { var f = e.target.closest('.pdt__photo'); if (f && !f.hasAttribute('data-pvideo') && O.isDesktop()) zoom(f); });
    var bz = O.$('[data-zoom]', root);
    if (bz) bz.addEventListener('click', function () { var i = Math.round(photos.scrollLeft / Math.max(1, photos.clientWidth)); zoom(visibles()[i]); });
    if (fen) fen.addEventListener('click', dezoom);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') dezoom(); });

    // Vidéos de la galerie (comme la vidéo « Emballage ») : sans son et en boucle quand elles sont visibles à 50 %,
    // pause hors de l'écran ou quand on change de coloris ; un clic (ou le bouton) met en pause / relance.
    // Le fichier n'est chargé qu'au premier lancement : 720p sur mobile, 1080p sur ordinateur.
    // « Réduire les animations » : rien ne démarre seul.
    O.$$('[data-pvideo]', photos).forEach(function (fig) {
      var vid = O.$('video', fig), btn = O.$('[data-pvideo-bouton]', fig), arretee = false;
      if (!vid) return;
      function sync() {
        var lit = !vid.paused, T = window.OBAIA_T || {};
        fig.classList.toggle('is-playing', lit);
        if (btn) btn.setAttribute('aria-label', lit ? (T.pause_video || 'Mettre la vidéo en pause') : (T.lire_video || 'Lire la vidéo'));
      }
      function lire() {
        if (!vid.getAttribute('src')) vid.src = (O.isDesktop() ? vid.getAttribute('data-hd') : vid.getAttribute('data-sd')) || vid.getAttribute('data-hd');
        var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {});
      }
      vid.addEventListener('play', sync);
      vid.addEventListener('pause', sync);
      fig.addEventListener('click', function () {
        if (vid.paused) { arretee = false; lire(); } else { arretee = true; vid.pause(); }
      });
      if (O.reduce || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio >= 0.5) { if (!arretee) lire(); }
          else if (!vid.paused) vid.pause();
        });
      }, { threshold: [0, 0.5] }).observe(fig);
    });

    /* Coloris ----------------------------------------------------------------- */
    function texte(sel, val) { O.$$(sel, root).forEach(function (el) { el.textContent = val; }); }
    function appliquer(v) {
      if (!v) return;
      courante = v; etat = v.etat; champ.value = v.id;
      root.setAttribute('data-etat', etat);
      texte('[data-prix]', v.prix);
      texte('[data-prix3]', v.prix3);
      texte('[data-barre-coloris]', v.nom || v.coloris || '');
      texte('[data-couleur-nom]', v.nom || v.coloris || '');
      O.$$('[data-si-precommande]', root).forEach(function (el) { el.hidden = etat !== 'precommande'; });
      var badge = O.$('[data-badge]', root); if (badge) badge.hidden = etat !== 'precommande';
      var lib = bouton.getAttribute('data-libelle-' + etat) || '';
      bouton.textContent = lib; bouton.disabled = etat === 'epuise';
      texte('[data-barre-libelle]', lib);
      if (note) note.textContent = note.getAttribute('data-note-' + etat) || '';
      var bn = O.$('[data-barre-note]', root); if (bn) bn.textContent = etat === 'precommande' ? ' · ' + (bn.getAttribute('data-texte') || bn.textContent.replace(/^ · /, '')) : '';
      // Vignette de la barre : la photo détourée du coloris choisi (celle du choix de la couleur), sinon la photo de la variante
      var choix = O.$('[data-coloris]:checked', root), lab = choix && choix.closest('label'), ph = lab && O.$('.pchoix__photo img', lab);
      var src = ph ? (ph.currentSrc || ph.src) : v.image;
      if (src) O.$$('[data-barre-image] img', root).forEach(function (img) { img.src = src; img.removeAttribute('srcset'); });
      filtrerPhotos(v.coloris);
      // Les « Pensés pour compléter votre sac » suivent la couleur choisie (plus bas)
      root.dispatchEvent(new CustomEvent('obaia:coloris', { detail: v }));
      if (window.history && history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
      }
    }
    var bn0 = O.$('[data-barre-note]', root); if (bn0) bn0.setAttribute('data-texte', bn0.textContent.replace(/^ · /, ''));
    O.$$('[data-coloris]', root).forEach(function (r) {
      r.addEventListener('change', function () {
        appliquer(variantes.filter(function (v) { return v.coloris === r.value; })[0]);
      });
    });
    filtrerPhotos(courante && courante.coloris);

    /* Quantité ------------------------------------------------------------------ */
    var qte = O.$('[data-qte] input', root);
    function pas(d) { qte.value = Math.max(1, (parseInt(qte.value, 10) || 1) + d); }
    var qm = O.$('[data-qte-moins]', root), qp = O.$('[data-qte-plus]', root);
    if (qm) qm.addEventListener('click', function () { pas(-1); });
    if (qp) qp.addEventListener('click', function () { pas(1); });

    /* Rubriques : onglets ------------------------------------------------------------ */
    var onglets = O.$$('[data-rub-onglet]', root);
    function montrer(b, focus) {
      onglets.forEach(function (o) {
        var actif = o === b;
        o.setAttribute('aria-selected', actif ? 'true' : 'false');
        o.tabIndex = actif ? 0 : -1;
        var pn = document.getElementById(o.getAttribute('aria-controls'));
        if (pn) pn.hidden = !actif;
      });
      // Mobile : la rangée défile pour montrer l'onglet choisi en entier
      var rang = b.parentNode, rr = rang.getBoundingClientRect(), br = b.getBoundingClientRect();
      if (br.right > rr.right || br.left < rr.left) rang.scrollTo({ left: rang.scrollLeft + br.left - rr.left, behavior: O.reduce ? 'auto' : 'smooth' });
      if (focus) b.focus();
    }
    onglets.forEach(function (b, k) {
      b.addEventListener('click', function () { montrer(b); });
      b.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        montrer(onglets[(k + d + onglets.length) % onglets.length], true);
      });
    });

    /* Ajout au panier ---------------------------------------------------------------- */
    var messageCase = form.getAttribute('data-message-case') || (window.OBAIA_T || {}).cocher_case || 'Merci de cocher la case pour confirmer la date d’expédition.';
    form.addEventListener('submit', function (e) {
      if (erreur) erreur.hidden = true;
      if (etat === 'precommande' && confirme && !confirme.checked) {
        e.preventDefault();
        var lab = confirme.closest('label'); lab.classList.add('is-erreur');
        if (erreur) { erreur.textContent = messageCase; erreur.hidden = false; }
        confirme.focus();
        return;
      }
      // Ajout sans recharger : le panier en tiroir s'ouvre (assets/obaia-panier.js, ajout de Nelson)
      if (window.OBAIA_PANIER) {
        e.preventDefault();
        bouton.disabled = true;
        window.OBAIA_PANIER.ajouterFormulaire(form).catch(function (err) {
          if (erreur) { erreur.textContent = (err && (err.description || err.message)) || (window.OBAIA_T || {}).erreur_ajout || 'Impossible d’ajouter cet article.'; erreur.hidden = false; }
        }).then(function () { bouton.disabled = false; });
      }
    });
    if (confirme) confirme.addEventListener('change', function () { confirme.closest('label').classList.remove('is-erreur'); if (erreur) erreur.hidden = true; });

    /* Défilement desktop (demande de Moha du 28/10) ------------------------------------------
       1. on fait défiler toutes les photos, la colonne d'achat reste en place ;
       2. arrivé à la dernière photo, elle reste à l'écran et c'est la colonne d'achat qui défile jusqu'à son bas ;
       3. puis la page continue. Les deux colonnes sont « sticky » ; la rangée est allongée du défilement de l'étape 2. */
    var achat = O.$('[data-achat]', root), pile = O.$('[data-photos]', root), MARGE = 32;
    function defilement() {
      if (!O.isDesktop()) { ['--achat-top', '--photos-top', '--rangee-h'].forEach(function (k) { root.style.removeProperty(k); }); return; }
      var haut = (O.$('[data-header]') || { offsetHeight: 72 }).offsetHeight + MARGE;
      var b = O.$('[data-barre]', root), barreH = b ? b.offsetHeight : 0;
      var vh = window.innerHeight, G = pile ? pile.offsetHeight : 0, A = achat.offsetHeight;
      // Retour de la cliente du 31/10 (comme sarale-paris.com) : pendant le défilement des photos, le bloc d'achat
      // reste fixe AVEC son bouton « Précommander » visible. Sur un écran bas, la colonne se cale plus haut
      // (le haut du titre passe sous l'en-tête) pour que le bouton et sa ligne d'info restent dans l'écran.
      var cible = O.$('[data-note]', achat) || bouton;
      var basBouton = cible.getBoundingClientRect().bottom - achat.getBoundingClientRect().top;
      var hautAchat = Math.round(Math.min(haut, vh - MARGE - basBouton));
      // Ce que la colonne d'achat doit encore défiler une fois la dernière photo atteinte (compté avec la barre d'achat ouverte)
      var reste = Math.max(0, A - (vh - MARGE - hautAchat - barreH));
      root.style.setProperty('--achat-top', hautAchat + 'px');
      root.style.setProperty('--barre-h', barreH + 'px');
      root.style.setProperty('--photos-top', Math.min(haut, vh - MARGE - G) + 'px');
      root.style.setProperty('--rangee-h', Math.max(G + reste, A) + 'px');
    }
    defilement(); window.addEventListener('resize', defilement);
    if (window.ResizeObserver) { var ro = new ResizeObserver(defilement); ro.observe(achat); if (pile) ro.observe(pile); }

    /* Barre d'achat fixe ---------------------------------------------------------------------- */
    var barre = O.$('[data-barre]', root);
    if (barre) {
      // Visible dès que le bouton principal est passé au-dessus de l'écran. En desktop, aussi tant qu'il est sous l'écran
      // pendant qu'on fait défiler les photos (la colonne d'achat reste en place) : la colonne descend alors sous la barre.
      var montree = null;
      var majBarre = function () {
        var r = bouton.getBoundingClientRect(), d = O.isDesktop();
        var montrer = r.bottom < 0 || (d && window.scrollY > 40 && r.top > window.innerHeight);
        if (montrer === montree) return;
        montree = montrer;
        barre.classList.toggle('is-visible', montrer);
        root.classList.toggle('is-barre', montrer && d);
        barre.setAttribute('aria-hidden', montrer ? 'false' : 'true');
        O.$('[data-barre-bouton]', barre).tabIndex = montrer ? 0 : -1;
      };
      window.addEventListener('scroll', function () { window.requestAnimationFrame(majBarre); }, { passive: true });
      majBarre();
      O.$('[data-barre-bouton]', barre).addEventListener('click', function () {
        if (etat === 'precommande' && confirme && !confirme.checked) {
          var y = confirme.closest('label').getBoundingClientRect().top + window.scrollY - window.innerHeight / 3;
          window.scrollTo({ top: y, behavior: O.reduce ? 'auto' : 'smooth' });
          confirme.closest('label').classList.add('is-erreur');
          return;
        }
        if (form.requestSubmit) form.requestSubmit(bouton); else bouton.click();
      });
    }

    /* Vidéos lues sur place --------------------------------------------------------------- */
    O.$$('[data-video]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var t = O.$('[data-video-source]', b.parentNode); if (!t) return;
        b.parentNode.appendChild(t.content.cloneNode(true));
        var vid = O.$('video', b.parentNode); b.remove();
        if (vid) { vid.play && vid.play().catch(function () {}); vid.focus(); }
      });
    });

    /* Pensés pour compléter votre sac ------------------------------------------------------- */
    var piste = O.$('[data-comp-piste]', root);
    if (piste) {
      var cartes = O.$$('[data-comp]', piste), pc = O.$('[data-comp-points]', root), i = 0;
      pc.innerHTML = cartes.length > 1 ? new Array(cartes.length + 1).join('<i></i>') : '';
      var prec = O.$('[data-comp-prec]', root), suiv = O.$('[data-comp-suiv]', root);
      // La piste prend la hauteur de la carte affichée (un nom sur deux lignes ne décale pas la page)
      function marquer(k) {
        i = k;
        O.$$('i', pc).forEach(function (p, n) { p.classList.toggle('is-actif', n === i); });
        if (cartes[i]) piste.style.height = cartes[i].offsetHeight + 'px';
      }
      // Flèches en boucle (Figma : les deux flèches restent actives).
      // Ordinateur : les cartes glissent (transform, variable --i) au lieu de faire défiler la piste. Safari ignore
      // souvent le défilement par script d'un bloc « overflow: hidden » à crans (scroll-snap) : la flèche ne faisait
      // rien chez la cliente (retour du 01/11). Mobile : la piste défile au doigt, on garde le défilement.
      var mobile = window.matchMedia('(max-width: 767px)');
      function aller(k) {
        var n = cartes.length; marquer(((k % n) + n) % n);
        if (mobile.matches) piste.scrollTo({ left: i * piste.clientWidth, behavior: O.reduce ? 'auto' : 'smooth' });
        else { piste.scrollLeft = 0; piste.style.setProperty('--i', i); }
      }
      prec.addEventListener('click', function () { aller(i - 1); });
      suiv.addEventListener('click', function () { aller(i + 1); });
      // Les points sont cliquables aussi (réflexe naturel ; ils restent hors tabulation, les flèches servent au clavier)
      pc.addEventListener('click', function (e) {
        var k = Array.prototype.indexOf.call(pc.children, e.target);
        if (k > -1) aller(k);
      });
      // Mobile : défilement au doigt, les points suivent
      var attente;
      piste.addEventListener('scroll', function () {
        clearTimeout(attente);
        attente = setTimeout(function () { var k = Math.round(piste.scrollLeft / Math.max(1, piste.clientWidth)); if (k !== i) marquer(k); }, 80);
      }, { passive: true });
      window.addEventListener('resize', function () { aller(i); });
      if (cartes.length < 2) { prec.hidden = true; suiv.hidden = true; }
      marquer(0);
      // Couleur du sac changée : chaque complément passe au même coloris s'il existe (ALBA taupe → étui taupe),
      // grâce aux <template data-comp-coul> préparés par Liquid (photo, nom, prix, lien) ; court fondu à l'arrivée.
      root.addEventListener('obaia:coloris', function (e) {
        var c = String((e.detail && e.detail.coloris) || '').toLowerCase();
        if (!c) return;
        cartes.forEach(function (carte) {
          var t = O.$$('template[data-comp-coul]', carte).filter(function (x) { return x.getAttribute('data-comp-coul') === c; })[0];
          if (!t || carte.getAttribute('href') === t.getAttribute('data-url')) return;
          Array.prototype.slice.call(carte.children).forEach(function (n) { if (n.tagName !== 'TEMPLATE') carte.removeChild(n); });
          carte.insertBefore(t.content.cloneNode(true), carte.firstChild);
          carte.setAttribute('href', t.getAttribute('data-url'));
          if (!O.reduce) { carte.classList.remove('is-maj'); void carte.offsetWidth; carte.classList.add('is-maj'); }
        });
        marquer(i);
      });
    }
  }

  O.section('produit', { init: init });
})();
